import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody, Button, CardTitle, CardSubtitle, Modal, ModalBody } from "reactstrap"
import { connect } from "react-redux"
import { withRouter, useParams, useLocation } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb";
// import Utils from '../Utility';
import Utils from '../Utility';
import Loader from "../../components/Loader";
import DataTable from 'react-data-table-component';
import { get, put } from '../../helpers/api_helper'
import { toast } from 'react-toastify';
// import DeleteModal from './DeleteModal';
import DeleteModal from '../../components/ConfirmModal/DeleteModal';
import moment from 'moment'
import { AvField, AvForm } from 'availity-reactstrap-validation'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';


const Enquiry = props => {
    const { user } = props;
    const [currentData, setCurrentData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [modal, setModal] = useState(false);

    useEffect(() => {
        if (user?.token)
            getData();
    }, [user]);

    const getData = () => {
        if (!loading) {
            setLoading(true);
            get("/subcs", { token: user?.token })
                .then(res => {
                    setLoading(false);
                    if (res?.statusCode == 200) {
                        setData(res?.data);
                    } else {
                        toast.error(res?.error);
                    }
                })
                .catch(err => {
                    setLoading(false);
                    console.log('error while getting enquiries', err);
                    toast.error('Something Went Wrong!');
                })
        }
    }

    useEffect(() => {
        setColumns([

            {
                name: 'Sl.No',
                cell: (row, index) => <>
                    <span>{index + 1}</span>
                </>,
                // maxWidth: '80px'
            },
            {
                name: "Position",
                cell: (row, index) => <>
                    <Draggable key={row._id} draggableId={row._id} index={index}>
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                            >
                                <i className="mdi mdi-menu" style={{ fontSize: 20, color: Utils.themeColor }}></i>
                            </div>
                        )}
                    </Draggable>
                </>,
                // maxWidth: '100px'
            },
            {
                name: 'Email',
                selector: row => row?.email,
                sortable: true,
                // maxWidth: '210px',
                minWidth: '150px'
            },

            {
                name: 'Created At',
                selector: row => moment(row?.createdAt).format("DD-MMM-YYYY"),
                sortable: true,
                // maxWidth: '200px'
                // minWidth: '100px'
            },
            // {
            //     cell: (row) => <>
            //         <Button onClick={() => handleUpdateStatus(row)}
            //             title={row?.isActive ? "Completed" : "Pending"}
            //             style={{ backgroundColor: !row.isActive ? 'green' : 'orange', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}>
            //             <span className="text-white" style={{}}>
            //                 {!row?.isActive ? 'Completed' : 'Pending'}
            //             </span>
            //         </Button>
            //     </>,
            //     name: 'Status',
            //     ignoreRowClick: true,
            //     maxWidth: '130px'
            // },
            {
                cell: (row) => <>
                    {/* <Button onClick={() => handleUpdateProj(row)}
                        title={"Reply"}
                        style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}><span className="mdi mdi-comment" style={{ fontSize: 20 }}></span></Button> */}
                    <Button onClick={() => handleDeleteProj(row)}
                        title={"Delete"}
                        style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none', height: 44 }}><span className="mdi mdi-delete" style={{ fontSize: 20 }}></span></Button>
                </>,
                name: 'Action',
                ignoreRowClick: true,
                maxWidth: '80px'
            },
        ]);
    }, [data]);

    const handleUpdateStatus = (row) => {
        setCurrentData({ ...row, actionType: 'Status' });
        setDeleteModal(true);
    }

    const handleDeleteProj = (row) => {
        setCurrentData(row);
        setDeleteModal(true);
    }

    const handleUpdateProj = (row) => {
        setCurrentData(row);
        setModal(true);
    }

    const onDelete = () => {
        setLoading(true);
        let body = {
            subcsId: currentData?._id,
            token: user?.token
        }
        if (currentData?.actionType == 'Status')
            body = { ...body, isActive: !currentData?.isActive }
        else
            body = { ...body, isDeleted: true }
        put("/subcs", body)
            .then(res => {
                setLoading(false);
                if (res?.statusCode == 200) {
                    // toast.success
                    toast.success(res?.message);
                    getData();
                    setDeleteModal(false);
                    setCurrentData(null);
                } else {
                    toast.error(res?.error);
                }
            })
            .catch(err => {
                setLoading(false);
                console.log('error while getting enquiries', err);
                toast.error('Something Went Wrong!');
            })
    }

    const handleValidSubmit = (e, v) => {
        let body = {
            subcsId: currentData?._id,
            reply: v?.reply,
            isActive: false,
            token: user?.token
        }
        put("/subcs", body)
            .then(res => {
                setLoading(false);
                if (res?.statusCode == 200) {
                    getData();
                    setModal(false);
                    setCurrentData(null);
                } else {
                    toast.error(res?.error);
                }
            })
            .catch(err => {
                setLoading(false);
                console.log('error while getting enquiries', err);
                toast.error('Something Went Wrong!');
            })
    }

    const handleDragEnd = (result) => {
        // console.log('dragging item', result);
        // Handle the drag-and-drop logic here
        if (!result.destination) return; // Item was dropped outside the list
        const items = [...data];
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        let ids = [], position = [];
        items.forEach((item, index) => {
            ids.push(item?._id);
            position.push(index);
        })
        let body = {
            ids,
            position,
            token: user?.token
        }
        put("/subcs/position", body)
            .then(res => {
                // if (res?.statusCode == 200)
                setData(items);
            })
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Loader visible={loading} />
                <Breadcrumb title={Utils.projectName} breadcrumbItem="Subscription" />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={() => onDelete()}
                    onCloseClick={() => setDeleteModal(false)}
                    data={currentData}
                />
                <Card>
                    <CardBody>
                        <Row>
                            <Col md={12}>
                                <CardTitle className="h4">Subscription</CardTitle>
                                {/* <CardSubtitle className="mb-3">
                                    Inquiries those who filled the contact us form, All the <code>Users will not be able </code> to fill that form again until you don't <code>Completed</code> that <code>Iquiry.</code>
                                </CardSubtitle> */}
                            </Col>
                        </Row>

                        <DragDropContext onDragEnd={handleDragEnd}>
                            <Droppable droppableId="table">
                                {(provided) => (
                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                        <DataTable
                                            columns={columns}
                                            data={data}
                                            pagination
                                            customStyles={{
                                                headCells: {
                                                    style: {
                                                        color: 'black',
                                                        fontWeight: 'bold',
                                                        fontSize: 15,
                                                        maxWidth: 80
                                                    },
                                                },
                                                cells: {
                                                    style: {
                                                        maxWidth: 50
                                                    }
                                                }
                                            }}
                                            conditionalRowStyles={[{
                                                when: row => row?.seen?.length < 1,
                                                style: { backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, color: 'white', cursor: 'pointer' },
                                            }]}
                                        // onRowClicked={(r, e) => seenNoti(r)}
                                        />
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>

                    </CardBody>
                </Card>
                {/* <Modal className="modal_form" isOpen={modal} toggle={() => { setModal(false) }} centered={true}>
                    <ModalBody className="py-3 px-5">
                        <h5 className="text-black font-size-20">{'User Contact Us'}</h5>
                        <div className="p-2">
                            <Row>
                                <Col md={12}>
                                    <span>User -<span><b> {currentData?.name}</b></span></span>
                                </Col>
                                <Col md={10}>
                                    <span>Email -<span><b> {currentData?.email}</b></span></span>
                                </Col>
                                <Col md={10} className='mb-2'>
                                    <span>Mobile -<span><b> {currentData?.user?.mobile}</b></span></span>
                                </Col>
                                <hr></hr>
                                <Col md={10}>
                                    <span><span><b> {currentData?.message}</b></span></span>
                                </Col>
                            </Row>
                        </div>
                        <div className="p-2">
                            <AvForm
                                className="form-horizontal"
                                onValidSubmit={(e, v) => {
                                    handleValidSubmit(e, v)
                                }}
                            >
                                <Row>
                                    <Col lg={12} md={12}>
                                        <div className="mt-4">
                                            <AvField
                                                type="textarea"
                                                rows={5}
                                                name="reply"
                                                label="Reply"
                                                placeholder={"Provide your detailed response or answer to the user's Contact here."}
                                                value={currentData?.reply}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={12} md={12}>
                                        <div className="mt-4">
                                            <Row>
                                                <Col md={6}>
                                                    <button
                                                        className="btn btn-primary w-100 waves-effect waves-light"
                                                        style={{ backgroundColor: Utils.themeColor, border: 'none' }}
                                                        onClick={() => { setModal(false) }}
                                                        type="reset"
                                                    >
                                                        Cancel
                                                    </button>
                                                </Col>
                                                <Col md={6}>
                                                    <button
                                                        className="btn btn-primary w-100 waves-effect waves-light"
                                                        type="submit"
                                                        style={{ backgroundColor: Utils.themeColor, border: 'none' }}
                                                    >
                                                        {currentData?.reply ? 'Update' : 'Reply'}
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </AvForm>
                        </div>
                    </ModalBody>
                </Modal> */}
            </div>
        </React.Fragment>
    )
}

const mapStatetoProps = state => {
    const { user } = state.Profile;
    return { user }
}

export default withRouter(
    connect(mapStatetoProps, {})(Enquiry)
)
